import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/utils.js';
export function Card({ className, ...props }) {
    return (_jsx("div", { className: cn('rounded-lg border border-gray-200 bg-white shadow-sm', className), ...props }));
}
export function CardHeader({ className, ...props }) {
    return _jsx("div", { className: cn('flex flex-col space-y-1.5 p-6', className), ...props });
}
export function CardTitle({ className, ...props }) {
    return (_jsx("h3", { className: cn('text-lg font-semibold leading-none tracking-tight', className), ...props }));
}
export function CardContent({ className, ...props }) {
    return _jsx("div", { className: cn('p-6 pt-0', className), ...props });
}
//# sourceMappingURL=Card.js.map